<template>
  <component
    :is="tag"
    class="Stat"
  >
    <TransitionGroup
      class="Stat__digitContainer"
      tag="span"
      :style="`transform: translateX(${(1 / spotCount - (digits.length - 1) / spotCount / 2) * 100}%)`"
    >
      <span
        v-for="(digit, i) in digits"
        :key="i"
        class="Stat__digit"
      >
        <span class="Stat__numberListContainer">
          <span
            class="Stat__numberList"
            :style="`transform: translateY(${-digit / numbers.length * 100}%)`"
          >
            <span
              v-for="number in numbers"
              :key="number"
              class="Stat__number"
            >{{ number }}</span>
          </span>
        </span>
      </span>
    </TransitionGroup>
  </component>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const modelValue = defineModel<number>({
  required: true,
});

const {
  tag = "div",
} = defineProps<{
  tag?: string,
}>();

const spotCount = 3;
const numbers = Array.from({
  length: 11,
}, (_, i) => i);

const digits = computed(() => {
  return modelValue.value.toString().split("")
    .map(Number);
});
</script>

<style lang="scss" scoped>
.Stat__digitContainer {
  display: flex;
  width: 3ch;
  height: 1lh;
  overflow: hidden;

  mask-image: linear-gradient(
    to bottom,
    transparent 0,
    black 4px,
    black calc(100% - 4px),
    transparent 100%
  );

  transition: transform 350ms;
}

.Stat__numberListContainer {
  display: block;
  width: 1ch;
}

.Stat__digit {
  display: block;
  transition: 350ms;
  transition-property: opacity, transform;

  &.v-enter-from,
  &.v-leave-to {
    transform: translateY(100%);
    opacity: 0;
  }
}

.Stat__numberList {
  display: grid;
  transition: transform 350ms;
}
</style>
